module.exports = __webpack_public_path__ + "img/esc_2_act_1.3987531e.png";